const isDev = (typeof window !== 'undefined' && window && window.location && window.location.hostname === 'localhost')
  || (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development')

const API_BASE = isDev ? 'http://localhost:8092' : ''

export { API_BASE }
export default API_BASE
